(function () {
    'use strict';

    angular
        .module('franchisee-portal.services')
        .service('BannerService', BannerService)

    /** @ngInject */
    function BannerService(HttpService) {
        const BannerService = {
            getAllByParameters: getAllByParameters
        }

        return BannerService;

        function getAllByParameters(params) {
            return HttpService.get('/banners', {
                params
            });
        }
    }
}());